// This file is generated by pnpm icons:generate. Do not edit.

import {EyeSlash_Stroke2_Corner0_Rounded as CanonicalEyeSlash_Stroke2_Corner0_Rounded} from './Eye'

/** @deprecated Import EyeSlash_Stroke2_Corner0_Rounded from `#/components/icons/Eye` instead. */
export const EyeSlash_Stroke2_Corner0_Rounded =
  CanonicalEyeSlash_Stroke2_Corner0_Rounded
